import * as React from 'react'
import {useLocation, useNavigate, useParams} from "react-router";
import {useMutation, useQuery} from "@tanstack/react-query";
import {setUrlToHTTPs} from "../../utils";
import {AppConf} from "../../AppConf";
import {useKeycloak} from "@nic-react/auth";
import {useAppendAuthorizationHeader} from "../../utils/connector/api-connector";
import Spinner from "../../components/Spinner/Spinner";
import BookingCalendar from "../../model/BookingCalendar";
import RequestAgenda from "../../components/agenda/RequestAgenda";
import dayjs from "dayjs";
import Flex from "../../components/StyledComponents/Flex";
import RequestController from "../RequestController";
import {notification} from "antd";
import {useTranslation} from "@nic-react-i18n/core";
import {queryClient} from "../../index";

interface BookingCalendarControllerI {}



interface TestDate {
    testDate: string
}


const BookingCalendarController: React.FC<BookingCalendarControllerI> = (props) => {
    const {keycloak} = useKeycloak()
    const {t} = useTranslation()
    const navigate = useNavigate()
    const location = useLocation()
    const params = useParams()
    console.log('Params: ', params)
    const header =  useAppendAuthorizationHeader()



    const bookDate = async (data: TestDate) => {
        const {url:rootAPI} = AppConf.getRootUrl(keycloak.realm)

        const response = await fetch(`${rootAPI}/requests/${params.id}/book`,
            {
                method: 'POST',
                body: JSON.stringify(data),
                ...header
            })
        if (!response.ok) {
            throw new Error()
        }
        return response.json()
    }


    const {mutateAsync } = useMutation(bookDate)


    const testsData = useQuery({
        queryKey: ['booking', 'calendar', params.month, params.year],
        queryFn: async () => {
            const {url:rootAPI} = AppConf.getRootUrl(keycloak.realm)
            const data =
                await fetch(setUrlToHTTPs(`${rootAPI}${location.pathname}`), {...header})
            return data.json()
        }})

    let component = <Spinner/>


    if (testsData.isFetched) {
        const calendar = testsData.data
        let bookingCalendar: BookingCalendar = new BookingCalendar();

        bookingCalendar.availableDates = calendar._embedded.availableDates;
        bookingCalendar.plans = calendar._embedded.plans;
        bookingCalendar.links = calendar._links;
        console.log('BookingCalendar: ', bookingCalendar);

        const year = params.year !== undefined ? +(params.year): dayjs().year()
        const month = params.month !== undefined ? +(params.month) : dayjs().month()+1
        const value = dayjs().year(year).month(month-1)

        component = (
            <RequestAgenda
                agenda={bookingCalendar}
                value={value}
                mode={'month'}
                selectHandler={() => {console.log('Selected')}}
                requestCalendar={true}
                baseURI={""}
                bookDate={(date: string) => {
                    mutateAsync({testDate: date})
                        .then((result: any) => {

                            notification.info(
                                {
                                    message: t('booking.notification.title'),
                                    description: t(
                                        'booking.notification.description',
                                        {giorno: dayjs(date).format('DD MMMM YYYY HH:mm zz')}
                                    )
                                });

                            queryClient.invalidateQueries({queryKey: ['requests', 'request', params.id]})

                            console.log('Result: ', result)
                        })
                        .catch(() => {
                            notification.error(
                                {
                                    message: t('booking.notification.title'),
                                    description: t(
                                        'booking.notification.error'
                                    )
                                });
                        })
                        .finally(() => {
                            notification.success(
                                {
                                    message: t('booking.notification.title'),
                                    description: t(
                                        'booking.notification.success')}
                            )

                            navigate(`/requests/${params.id}`)
                        });
                }}
            />
        )

    }



    return (
        <Flex direction={'column'} style={{width: '100%'}}>
            <RequestController/>
            {component}
        </Flex>
    )
}

export default BookingCalendarController